<template>
  <div class="order-details">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="客户信息" name="first">
          <el-scrollbar>
            <div style="width: 100%">
              <el-col :span="8">
                <el-form-item label="订单编号">
                  <el-input :value="form.fBillNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户">
                  <el-input :value="form.fCustomer" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票名称">
                  <el-input :value="form.fBillingName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货人">
                  <el-input :value="form.fName_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话">
                  <el-input :value="form.fPhone" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收货地址">
                  <el-input :value="form.fAddress_sh" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经营许可号">
                  <el-input :value="form.fBusinessNo" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经营地址">
                  <el-input :value="form.fAddress_jy" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="区域">
                  <el-input :value="form.fRegion" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运费付款方式">
                  <el-input :value="form.fPayType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="仓库">
                  <el-input :value="form.fStock" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发货方式">
                  <el-input :value="form.fDeliverType" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="交货日期">
                  <el-input :value="form.fDate" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="付款比例(%)">
                  <el-input :value="form.fDeductionRatio" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注">
                  <el-input :value="form.fDes" disabled type="textarea" :rows="4" />
                </el-form-item>
              </el-col>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="订单信息" name="second">
          <el-table :data="form.entrys" height="100%">
            <el-table-column label="产品编号" prop="fNumber" width="120px" />
            <el-table-column label="产品名称" prop="fName" />
            <el-table-column label="规格" prop="fModel" />
            <el-table-column label="单位" prop="fUnit" width="50px" />
            <el-table-column label="数量" prop="fQty" width="100px" />
            <el-table-column label="备注" prop="fDes" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
export default {
  data: function() {
    return {
      radio: null,
      form: {
        entrys: []
      },

      rules: {},

      activeName: 'first',

      loading: false,
      saving: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  mounted() {},
  methods: {
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost('OrderManage/Order/GetOrder', {
        fid: id
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }
      this.form = res.datalist
      const date = res.datalist.fDate
      if (date == undefined || date == 'Invalid date') {
        this.form.fDate = ''
      }
      this.form.fDate = moment(date).format('YYYY-MM-DD')
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang='less'>
.order-details {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 150px);
      .el-tab-pane {
        height: calc(100vh - 150px);
      }
    }
  }
}
</style>
